import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import proIcon from "../../media/images/pro-icon.png";
import custIcon from "../../media/images/customer-icon.png";
import JoinAsField from "../../jsx/components/fields/joinAsField";
import InputField from "../../jsx/components/fields/inputField";
import "./auth.scss";
import PhonenumberField from "../../jsx/components/fields/phoneFields";
import { waitingUserJoin } from "../../service/api/user/waitingUserJoin";
import {
  emailValidation,
  firstNameValidation,
  minLengthValidation,
  noSpaceOnChange,
  phoneOnChange,
  phoneValidation,
} from "../../validations/validation";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";

import {
  btnAlreadyAUser,
  btnCustomer,
  btnProfessional,
  btnRegister,
  btnTermsConditions,
  lblConfirmPasword,
  lblEmail,
  lblFirstName,
  lblLastName,
  lblPassword,
  txtCreateAccount,
  txtRegisterAs,
  txtSearchAddress,
  txtSignUpAs,
} from "../../dataBaseFile/label";
import { btnJoinWaiting } from "../../dataBaseFile/alert";
import {
  acceptTermsCondition,
  enterFirstName,
  errEmptyEmailOrPhone,
  errEmptyPassword,
  validEmailText,
  validEmail_OR_MobileNumberText,
  validFirstName,
  validMobileNumberText,
  validPassword,
} from "../../dataBaseFile/error";

import PasswordField from "../../jsx/components/fields/passwordField";
import {
  confirmPasswordValidation,
  passwordValidation,
} from "../../functions/validations";
import PasswordChecker from "../../component/passwordChecker/passwordChecker";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { searchAddress } from "../../service/api/user/searchAddress";
import { apiRegisterCompany } from "../../service/api/companies/registerCompany";
import { getCat } from "../../service/api/object/getCat";
import logo from "../../icons/photos/chillLogo.png";
import SkipButton from "../../jsx/components/button/skipButton";
import { accountExistenceCheckApi } from "../../service/api/user/checkAccountExistence";
import { activateUser } from "../../service/api/user/activationCode";
import { forgotPassword } from "../../service/api/user/forgotPassword";
import { validateSecurityCode } from "../../service/api/user/validateSecurityCode";
import { resetPassword } from "../../service/api/user/resetPassword";
import forgotPasswordImg from "../../media/images/authAssets/forgotPasswordImg.png";
import forgotBackgroundImg from "../../media/images/authAssets/forgotBackgroundImg.jpg";
import FeedbackModal from "../../jsx/components/feedback/feedback";
import { encryptPassword } from "../../service/encryptPassword";



export default function ForgotPassword(props) {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [isEmailError, setIsEmailError] = useState(false);
  const [phonenumber, setPhonenumber] = useState("");
  const [isPhoneError, setIsPhoneError] = useState(false);
  const [countryCode, setCountryCode] = useState("1");
  const [role, setRole] = useState("");
  const [isCheckedB, setIsCheckedB] = useState(true);
  const dispatch = useDispatch();
  const [isPassword, setIsPassword] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [isPasswordConfirm, setIsPasswordConfirm] = useState(false);

  const [isFocused, setIsFocused] = useState(false);
  const [errorFirstNameMsg, setErrorFirstNameMsg] = useState("");
  const [errorEmailMsg, setErrorEmailMsg] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");

  const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
  const [emailPhoneValue, setEmailPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState(1);
  const [isPhone, setIsPhone] = useState(false);
  const [loginErrorMsg, setLoginErrorMsg] = useState("");
  const [password, setPassword] = useState("");

  console.log(codeValue, "codevalue from forgot password");

  const [isNewPassword, setIsNewPassword] = useState(false);
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [loaderActive, setLoaderActive] = useState(false);

  const [loading, setLoading] = useState(false);

  const [responceMsg, setResponceMsg] = useState("");
  const [toasterType, setToasterType] = useState();
  const [handleToaster, setHandleToaster] = useState(false);

  const [feedbackMessage, setFeedbackMessage] = useState("")
  const [feedbackModal, setFeedbackModal] = useState(false);

  const handleNewPassword = (e) => {
    setIsNewPassword(false);
    setNewPassword(e.target.value);
  };
  const handleConfirmPassword = (e) => {
    setIsConfirmPassword(false);
    setConfirmPassword(e.target.value);
  };

  function handleNewPasswordBlur() {
    if (!passwordValidation(newPassword)) {
      setIsNewPassword(true);
    }
  }

  function handleConfirmPasswordBlur() {
    if (!confirmPasswordValidation(newPassword, confirmPassword)) {
      setIsConfirmPassword(true);
    }
  }
  const handlePassword = (e) => {
    setIsPassword(false);
    setPassword(e.target.value);
  };
  const handleBlurPassword = () => {
    setIsFocused(false);
    if (!passwordValidation(password)) {
      setIsPassword(true);
      if (password === "") {
        setPasswordErrorMsg(errEmptyPassword);
      } else {
        setPasswordErrorMsg(validPassword);
      }
    }
  };

  const handlePasswordConfirm = (e) => {
    setIsPasswordConfirm(false);
    setPasswordConfirm(e.target.value);
  };
  const handleBlurPasswordConfirm = () => {
    if (!confirmPasswordValidation(password, passwordConfirm)) {
      setIsPasswordConfirm(true);
    }
  };

  const onLogin= async (e) => {
    e?.preventDefault();

    const encryptedPassword = await encryptPassword(password);
    const encryptedPasswordConfirm = await encryptPassword(passwordConfirm);

    if (
      passwordValidation(password) &&
      confirmPasswordValidation(password, passwordConfirm)
    ) {
      if (firstNameValidation(firstName) && isCheckedB) {
        var roleArrayList = [];
        roleArrayList.push(parseInt(role));
        if (phonenumber.length > 0 && email.length === 0) {
          // case 1

          if (phoneValidation(phonenumber)) {
            setLoaderActive(true);
            let details = {
              first_name_chr: firstName,
              last_name_chr: lastName,
              role_id_list: roleArrayList,
              phone_code_id_int: parseInt(countryCode) || 0,
              phone_number_int: parseInt(phonenumber),
              email_chr: "",
              password: encryptedPassword,
              confirm_password: encryptedPasswordConfirm,
              creator_user_id_ids: "",
              company_id_ids: 0,
              company_onboarding_flag: 0,
            };

            let formData = new FormData();
            parseInt(countryCode) &&
              formData.append("phone_code_id_int", parseInt(countryCode) || 0);
            parseInt(phonenumber) &&
              formData.append("phone_number_int", parseInt(phonenumber));
            email && formData.append("email_chr", "");
            formData.append(
              "otp_chr",
              localStorage.getItem("security_code_chr")?.trim()
            );
            formData.append("first_name_chr", firstName);
            formData.append("last_name_chr", lastName);
            formData.append("role_id_int", parseInt(role));
            formData.append("password_chr", encryptedPassword);
            formData.append("create_account_flag", 1);

            dispatch(
              // waitingUserJoin(
              // signUp
              activateUser(
                formData,
                (res) => {
                  // openNotification('success', 'topRight', res.data.message)
                  localStorage.setItem("receiverPlatform", phonenumber);
                  localStorage.setItem(
                    "receiverPlatformPhoneCode",
                    countryCode
                  );

                  setResponceMsg(res.data.message);
                  setLoaderActive(false);
                  setToasterType("success");
                  setHandleToaster(true);

                  setTimeout(() => {
                    setHandleToaster(false);
                  }, 11000);

                  setSignUpSteps(5);
                },
                (error) => {
                  // openNotification('failed', 'topRight', error.data.message)
                  setResponceMsg(error.data.message);
                  setToasterType("errror");
                  setHandleToaster(true);

                  setTimeout(() => {
                    setHandleToaster(false);
                  }, 11000);
                }
              )
            );
          } else {
            setIsPhoneError(true);
          }
        }

        if (email.length > 0 && phonenumber.length === 0) {
          //case 2

          if (emailValidation(email)) {
            setLoaderActive(true);
            let details = {
              first_name_chr: firstName,
              last_name_chr: lastName,
              role_id_list: roleArrayList,
              phone_code_id_int: 0,
              phone_number_int: 0,
              email_chr: email,
              password: encryptedPassword,
              confirm_password: encryptedPasswordConfirm,
              creator_user_id_ids: "",
              company_id_ids: 0,
              company_onboarding_flag: 0,
            };

            let formData = new FormData();
            // parseInt(countryCode) && formData.append("phone_code_id_int",  0);
            // parseInt(phonenumber) && formData.append("phone_number_int", 0);
            email && formData.append("email_chr", email);
            formData.append(
              "otp_chr",
              localStorage.getItem("security_code_chr")?.trim()
            );
            formData.append("first_name_chr", firstName);
            formData.append("last_name_chr", lastName);
            formData.append("role_id_int", parseInt(role));
            formData.append("password_chr", encryptedPassword);
            formData.append("create_account_flag", 1);

            dispatch(
              activateUser(
                formData,
                (res) => {
                  localStorage.setItem("receiverPlatform", email);
                  setLoaderActive(false);

                  setResponceMsg(res.data.message);
                  setToasterType("success");

                  setHandleToaster(true);
                  setTimeout(() => {
                    setHandleToaster(false);
                  }, 11000);

                  setSignUpSteps(5);
                },
                (error) => {
                  setLoaderActive(false);
                  // openNotification('failed', 'topRight', error.data.message)
                  setResponceMsg(error.data.message);
                  setToasterType("error");

                  setHandleToaster(true);
                  setTimeout(() => {
                    setHandleToaster(false);
                  }, 11000);
                }
              )
            );
          } else {
            setIsEmailError(true);
            if (email === "") {
              setErrorEmailMsg("Please enter email");
            } else {
              setErrorEmailMsg(validEmailText);
            }
          }
        }

        if (email.length > 0 && phonenumber.length > 0) {
          // case 3

          if (emailValidation(email) && phoneValidation(phonenumber)) {
            setLoaderActive(true);
            let details = {
              first_name_chr: firstName,
              last_name_chr: lastName,
              role_id_list: roleArrayList,
              phone_code_id_int: parseInt(countryCode) || 0,
              phone_number_int: parseInt(phonenumber) || 0,
              email_chr: email,
              password: encryptedPassword,
              confirm_password: encryptedPasswordConfirm,
              creator_user_id_ids: "",
              company_id_ids: 0,
              company_onboarding_flag: 0,
            };

            let formData = new FormData();
            parseInt(countryCode) &&
              formData.append("phone_code_id_int", parseInt(countryCode) || 0);
            parseInt(phonenumber) &&
              formData.append("phone_number_int", parseInt(phonenumber) || 0);
            email && formData.append("email_chr", email);
            formData.append(
              "otp_chr",
              localStorage.getItem("security_code_chr")?.trim()
            );
            formData.append("first_name_chr", firstName);
            formData.append("last_name_chr", lastName);
            formData.append("role_id_int", parseInt(role));
            formData.append("password_chr", encryptedPassword);
            formData.append("create_account_flag", 1);

            dispatch(
              activateUser(
                formData,
                (res) => {
                  localStorage.setItem("receiverPlatform", email);

                  setLoaderActive(false);
                  // navigate('/verifyEmailPhone')
                  setResponceMsg(res.data.message);
                  setToasterType("success");

                  setHandleToaster(true);
                  setTimeout(() => {
                    setHandleToaster(false);
                  }, 4000);

                  setSignUpSteps(5);
                },
                (error) => {
                  setResponceMsg(error.data.message);
                  setToasterType("error");

                  setHandleToaster(true);
                  setTimeout(() => {
                    setHandleToaster(false);
                  }, 4000);

                  setLoaderActive(false);
                }
              )
            );
          } else {
            if (!emailValidation(email)) {
              setIsEmailError(true);
              if (email === "") {
                setErrorEmailMsg("Please enter email");
              } else {
                setErrorEmailMsg(validEmailText);
              }
            }
            if (!phoneValidation(phonenumber)) {
              setIsPhoneError(true);
            }
          }
        }

        if (email.length === 0 && phonenumber.length === 0) {
          setIsPhoneError(true);
          setIsEmailError(true);
          if (email === "") {
            setErrorEmailMsg("Please enter email and/or mobile number");
          } else {
            setErrorEmailMsg(validEmailText);
          }
        }
      } else {
        if (!firstNameValidation(firstName)) {
          setIsFirstNameError(true);

          if (firstName === "") {
            setErrorFirstNameMsg(enterFirstName);
          } else {
            setErrorFirstNameMsg(validFirstName);
          }
        }
      }
      if (isCheckedB) {
        // alert("Please use valid source to sign up");
      }
    } else {
      setIsPasswordConfirm(true);
      setIsPassword(true);
    }
  }



  useEffect(() => {
    const dot = ".";
    const leng = emailPhoneValue.length - 1;
    if (!isNaN(emailPhoneValue) && emailPhoneValue.charAt(leng) !== dot) {
      if (emailPhoneValue.length < 11) {
        setIsPhone(true);
      } else {
        setIsPhone(false);
      }
    } else {
      setIsPhone(false);
    }
    if (emailPhoneValue === "") {
      setIsPhone(false);
    }
  }, [emailPhoneValue]);

  const handleEmailPhone = (e) => {
    // console.log(e.target.value);
    setIsEmailPhoneVal(false);
    noSpaceOnChange(e.target.value) && setEmailPhoneValue(e.target.value);
  };

  const handleDropdownValue = (e) => {
    // setCodeValue(e.target.value);
    setCodeValue(e);
  };


  function handleBlur() {
    if (isPhone) {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!phoneValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    } else {
      if (emailPhoneValue === "") {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(errEmptyEmailOrPhone);
      } else if (!emailValidation(emailPhoneValue)) {
        setIsEmailPhoneVal(true);
        setLoginErrorMsg(validEmail_OR_MobileNumberText);
      }
    }
  }

  // Business Registration starts here-------------------
  const [businessRegToggle, setBusinessRegToggle] = useState(false);
  const [addressLine1, setAddressLine1] = useState(" ");
  const [addressLine2, setAddressLine2] = useState(" ");
  const [cityName, setCityName] = useState("");
  const [stateName, setStateName] = useState("");
  const [countryName, setCountryName] = useState(" ");
  const [zipCode, setZipCode] = useState(" ");
  const [latVal, setLatVal] = useState(0);
  const [longVal, setLongVal] = useState(0);
  const [address, setAddress] = useState("");
  const [placeIdVal, setPlaceId] = useState("");
  const [addressArr, setAddressArr] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isCompanytNameError, setIsCompanyNameError] = useState(false);
  const [companyName, setComapanyName] = useState("");
  const [isCompanytEmailError, setIsCompanyEmailError] = useState(false);
  const [companyEmail, setComapanyEmail] = useState("");

  const [photoToUpload, setPhotoToUpload] = useState(null);
  const [companyAvatarUrl, setCompanyAvatarUrl] = useState("");
  const [isAddress, setIsAddress] = useState(false);

  const [resMessage, setResMessage] = useState("");

  const [catApiCall, setCatApiCall] = useState(false);

  const handleBusinessRegToggle = () => {
    setBusinessRegToggle(!businessRegToggle);
    clearStatesBusinessReg();
    setCatApiCall(true);
  };

  // function to clear states after the toggle of business registration
  const clearStatesBusinessReg = () => {
    setFirstName("");
    setIsFirstNameError(false);
    setLastName("");
    setComapanyName("");
    setIsCompanyNameError(false);
    setComapanyEmail("");
    setIsEmailError(false);
    setPhonenumber("");
    setIsPhoneError(false);

    setAddressLine1("");
    setAddressLine2(" ");
    setCityName("");
    setStateName("");
    setCountryName(" ");
    setZipCode("");
    setLatVal(0);
    setLongVal(0);
    setAddress("");
    setPlaceId("");
    setAddressArr([]);
    setSearchText("");

    setPhotoToUpload(null);
    setCompanyAvatarUrl("");
    setIsAddress(false);
    setRole("");
  };

  useEffect(() => {
    const timeOutId = setTimeout(searchCalling, 1000);
    return () => clearTimeout(timeOutId);
  }, [searchText]);

  function searchCalling() {
    if (searchText.trim().length > 2) {
      let details = {
        address_chr: searchText.trim(),
      };
      dispatch(
        searchAddress(details, (res) => {
          setAddressArr(res.data.data);
        })
      );
    }
  }

  function handleCompanyNameBlurCheck() {
    if (companyName.length < 2) {
      setIsCompanyNameError(true);
    }
  }
  function handleCompanyName(e) {
    setComapanyName(e.target.value);
    setIsCompanyNameError(false);
  }

  function handleCompanyEmailBlurCheck() {
    if (emailValidation(companyEmail)) {
      setIsEmailError(false);
    } else {
      setIsEmailError(true);
    }
  }
  function handleCompanyEmail(e) {
    setComapanyEmail(e.target.value);
    setIsEmailError(false);
    setIsPhoneError(false);
  }

  const profileImgRef = useRef();
  function handlePhotoSelected(e) {
    setPhotoToUpload(e.target.files[0]);
    // console.log(e.target.files[0])
  }
  const handleClickProfileImg = () => {
    profileImgRef.current.click();
  };

  // Add expertise functions

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [expertiseArray, setExpertiseArray] = useState([]);
  const [pageSizeCat, setPageSizeCat] = useState(25);
  const [pageCat, setPageCat] = useState(1);
  const [catOrder, setCatOrder] = useState("ASC");
  const [catArr, setCatArr] = useState([]);

  useEffect(() => {
    if (catApiCall) {
      var forCatData = {
        page_index: pageCat,
        page_size: pageSizeCat,
        sorting_order: catOrder,
      };

      dispatch(
        getCat(forCatData, (res) => {
          setCatArr(res.data.data);
        })
      );
    }
  }, [catApiCall]);

  const options = catArr?.map((category) => ({
    value: category.category_id_ids,
    label: category.category_name_chr,
  }));

  const handleChange = (selected) => {
    setSelectedOptions(selected || []);
  };

  useEffect(() => {
    setExpertiseArray(selectedOptions.map((option) => option.value));
  }, [selectedOptions]);
  // Business Registration ends here------------------

  const [signUpSteps, setSignUpSteps] = useState(1);
  const [accountType, setAccountType] = useState("phone");
  const [isRoleSelected, setIsRoleSelected] = useState(false);

  // console.log("Email", email);
  // console.log("Phonenumber", phonenumber);
  // console.log("countryCode", countryCode);

  useEffect(() => {
    // If email then optional will phone and vice versa
    if (localStorage.getItem("emailPhoneVal")) {
      if (emailValidation(localStorage.getItem("emailPhoneVal"))) {
        setAccountType("phone");
        setEmail(localStorage.getItem("emailPhoneVal"));
      }

      if (phoneValidation(localStorage.getItem("emailPhoneVal"))) {
        setAccountType("email");
        setPhonenumber(localStorage.getItem("emailPhoneVal"));
        setCountryCode(localStorage.getItem("countryCodeVal"));
      }
    }
  }, [localStorage.getItem("emailPhoneVal")]);

  const handleCheckStepFirstName = (e) => {
    e?.preventDefault();
    if (!firstNameValidation(firstName)) {
      setIsFirstNameError(true);

      if (firstName === "") {
        setErrorFirstNameMsg(enterFirstName);
      } else {
        setErrorFirstNameMsg(validFirstName);
      }
    } else {
      setSignUpSteps(2);
    }
  };

  const checkIfEmailOrPhoneExists = () => {
    if (accountType === "email") {
      if (emailValidation(email)) {
        setLoaderActive(true);
        let details = new FormData();
        details.append("phone_code_id_int", 0);
        details.append("phone_number_int", 0);
        details.append("email_chr", email);
        details.append("create_account_flag", 0);
        dispatch(
          accountExistenceCheckApi(
            details,
            (res) => {
              setLoaderActive(false);
              if (res.data.account_exists) {
                setResponceMsg("Email already exists");
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }
              if (!res.data.account_exists) {
                setSignUpSteps(3);
              }
            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    }

    if (accountType === "phone") {
      if (phoneValidation(phonenumber)) {
        setLoaderActive(true);
        let details = new FormData();
        details.append("phone_code_id_int", parseInt(countryCode) || 1);
        details.append("phone_number_int", parseInt(phonenumber));
        details.append("email_chr", "");
        details.append("create_account_flag", 0);
        dispatch(
          accountExistenceCheckApi(
            details,
            (res) => {
              setLoaderActive(false);
              if (res.data.account_exists) {
                setResponceMsg("Phone number already exists");
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }
              if (!res.data.account_exists) {
                setSignUpSteps(3);
              }
            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err.data.message);
              setToasterType("success");
              setHandleToaster(true);
              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    }
  };

  const handleCheckStepEmailPhone = (e) => {
    e?.preventDefault();
    if (accountType === "email") {
      if (!emailValidation(email)) {
        setIsEmailError(true);
        if (email === "") {
          setErrorEmailMsg("Please enter email");
        } else {
          setErrorEmailMsg(validEmailText);
        }
      } else {
        checkIfEmailOrPhoneExists();
      }
    }

    if (accountType === "phone") {
      if (!phoneValidation(phonenumber)) {
        setIsPhoneError(true);
      } else {
        checkIfEmailOrPhoneExists();
      }
    }
  };

  const handleCheckStepRoleSelected = () => {
    if (isRoleSelected) {
      setSignUpSteps(4);
    }
  };

  const handleCheckStepPassword = (e) => {
    e?.preventDefault();
    if (!passwordValidation(password)) {
      setIsPassword(true);
      if (password === "") {
        setPasswordErrorMsg(errEmptyPassword);
      } else {
        setPasswordErrorMsg(validPassword);
      }
    }
    if (!confirmPasswordValidation(password, passwordConfirm)) {
      setIsPasswordConfirm(true);
    }
    if (
      passwordValidation(password) &&
      confirmPasswordValidation(password, passwordConfirm)
    ) {
      // setSignUpSteps(5);
      onLogin();
    }
  };

  const handleBackSignup = () => {
    if (signUpSteps == 1) {
      window.history.back();
    } else {
      setLoaderActive(false)
      setSignUpSteps(signUpSteps - 1);
    }
  };

  const [validateCode, setValidateCode] = useState(false);

  const [recievedCodeValue, setRecievedCodeValue] = useState("");
  const [isCodeError, setIsCodeError] = useState(false);

  const handleSubmitCode = (e) => {
    e.preventDefault()
    if (recievedCodeValue.length !== 0) {
      if (
        emailValidation(emailPhoneValue) ||
        phoneValidation(emailPhoneValue)
      ) {
        if (isPhone) {
          setLoaderActive(true);
          let details = {
            phone_code_id_int: parseInt(codeValue) || 1,
            phone_number_int: parseInt(emailPhoneValue),
            email_chr: "",
            security_code_chr: recievedCodeValue?.trim(),
          };
          dispatch(
            validateSecurityCode(
              details,
              (res) => {
                localStorage.setItem("securityCode", recievedCodeValue?.trim());
                setSignUpSteps(3);
                setResponceMsg(res.data.message);
                setToasterType("success");
                setHandleToaster(true);
                setLoaderActive(false);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              },
              (err) => {
                setResponceMsg(err.data.message);
                setToasterType("error");
                setHandleToaster(true);
                setLoaderActive(false);

                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }
            )
          );
        } else {
          setLoaderActive(true);
          let details = {
            phone_code_id_int: parseInt(codeValue) || 1,
            phone_number_int: parseInt(emailPhoneValue),
            email_chr: emailPhoneValue,
            security_code_chr: recievedCodeValue?.trim(),
          };

          dispatch(
            validateSecurityCode(
              details,
              (res) => {
                localStorage.setItem("securityCode", recievedCodeValue?.trim());
                setSignUpSteps(3)
                setResponceMsg(res.data.message);
                setToasterType("success");
                setHandleToaster(true);
                setLoaderActive(false);

                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              },
              (err) => {
                setResponceMsg(err.data.message);
                setToasterType("error");
                setHandleToaster(true);
                setLoaderActive(false);

                setTimeout(() => {
                  setHandleToaster(false);
                }, 11000);
              }
            )
          );
        }
      }
    } else {
      setIsCodeError(true);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();


    if (
      emailValidation(emailPhoneValue) ||
      phoneValidation(emailPhoneValue)
    ) {
      if (isPhone) {
        setLoaderActive(true);
        let details = {
          phone_code_id_int: parseInt(codeValue) || 1,
          phone_number_int: parseInt(emailPhoneValue),
          email_chr: "",
        };

        dispatch(
          forgotPassword(
            details,
            (res) => {
              setValidateCode(true);
              setLoaderActive(false);
              setSignUpSteps(2)
              localStorage.setItem("countryCodeVal", codeValue);
              localStorage.setItem("emailPhoneVal", emailPhoneValue);
              setResponceMsg(res.data.message);
              setToasterType("success");
              setHandleToaster(true);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            },
            (error) => {
              setLoaderActive(false);
              setResponceMsg(error.data.message);
              setToasterType("error");
              setHandleToaster(true);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      } else {
        let details = {
          phone_code_id_int: null,
          phone_number_int: null,
          email_chr: emailPhoneValue,
        };
        setLoaderActive(true);
        dispatch(
          forgotPassword(
            details,
            (res) => {
              setValidateCode(true);
              setLoaderActive(false);
              setSignUpSteps(2)
              localStorage.setItem("emailPhoneVal", emailPhoneValue);
              setResponceMsg(res.data.message);
              setToasterType("success");
              setHandleToaster(true);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            },
            (err) => {
              setLoaderActive(false);
              setResponceMsg(err.data.message);
              setToasterType("error");
              setHandleToaster(true);

              setTimeout(() => {
                setHandleToaster(false);
              }, 11000);
            }
          )
        );
      }
    } else {
      setLoaderActive(false);
      setIsEmailPhoneVal(true);
    }

  };
  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    const encryptedPassword = await encryptPassword(newPassword);
    const encryptedPasswordConfirm = await encryptPassword(confirmPassword);

    if (passwordValidation(newPassword)) {
      if (confirmPasswordValidation(newPassword, confirmPassword)) {

        if (emailValidation(emailPhoneValue)) {
          setLoaderActive(true)
          let details = {
            phone_code_id_int: 0,
            phone_number_int: 0,
            email_chr: localStorage.getItem("emailPhoneVal"),
            new_password: encryptedPassword,
            confirm_password: encryptedPasswordConfirm,
            security_code_chr: recievedCodeValue?.trim(),
          };
          dispatch(
            resetPassword(
              details,
              (res) => {

                setResponceMsg(res.data.message);
                setToasterType("success");
                setNewPassword("");
                setConfirmPassword("");
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                  navigate("/");
                  setLoaderActive(false)
                }, 3000);
              },
              (error) => {
                setLoaderActive(false)
                setResponceMsg(error.data.message);
                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 1000);
              }
            )
          );
        } else if (phoneValidation(emailPhoneValue)) {
          setLoaderActive(true)
          let details = {
            phone_code_id_int: parseInt(localStorage.getItem("countryCodeVal")),
            phone_number_int: parseInt(localStorage.getItem("emailPhoneVal")),
            email_chr: "",
            new_password: encryptedPassword,
            confirm_password: encryptedPasswordConfirm,
            security_code_chr: recievedCodeValue?.trim(),
          };
          dispatch(
            resetPassword(
              details,
              (res) => {
                navigate("/");
                setLoaderActive(false)
                setResponceMsg(res.data.message);
                setToasterType("success");
                setNewPassword("");
                setConfirmPassword("");
                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);

                }, 1000);
              },
              (error) => {
                setLoaderActive(false)
                setResponceMsg(error.data.message);
                setToasterType("error");

                setHandleToaster(true);
                setTimeout(() => {
                  setHandleToaster(false);
                }, 1000);
              }
            )
          );
        }


      } else {
        setIsConfirmPassword(true);
      }
    } else {
      setIsNewPassword(true);
      setLoaderActive(false)
    }
  };

  function handleValidateCode(e) {
    setIsCodeError(false);
    setRecievedCodeValue(e.target.value);
  }
  function handleCodeBlurCheck() {
    if (recievedCodeValue.length === 0) {
      setIsCodeError(true);
    }
  }

  function handleFeedbackModal(type, message) {
    setFeedbackMessage(message)
    setFeedbackModal(false);
    // setHandleToaster(true);
    // setTimeout(() => {
    //     setHandleToaster(false);
    // }, 11000);
  }

  return (
    <>
      <div className="row d-flex signUp-parent-container">
        <div className="col-xl-3 col-lg-3 col-md-4 align-items-center justify-content-between flex-column h-100 signUp-left-container border-end ">
          <div
            className="align-items-center d-flex justify-content-center row w-100 p-4"
            style={{
              background: 'rgba(251, 252, 255, 1)'
            }}
          >
            <img
              src={logo}
              style={{ cursor: "pointer", maxWidth: "150px" }}
              alt=""
              onClick={() => navigate("/login")}
            />

            <div className="fs-7 text-center mt-2 font-w500">
              <span className="">{`A new way to look at home repairs`}</span>
            </div>
          </div>

          <div
            className="align-items-center h-100 justify-content-center row w-100"
            style={{
              backgroundImage: `url(${forgotBackgroundImg})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '40% 50%',
              backgroundColor: 'orange',
            }}
          >

            <div
              className=" p-4 rounded-2 w-auto position-relative"
              style={{
                background: 'rgba(251, 252, 255, 1)',
              }}
            >
              {/* <div 
                className="position-absolute top-0 start-0 h-100"
                style={{width:'25px', background:'rgba(255, 255, 255, 1)'}}
              >

              </div> */}

              <div className=" d-flex flex-column ">
                <div className="d-flex flex-column justify-content-center align-items-center mb-3">
                  <img src={forgotPasswordImg} alt="" style={{ width: '65px' }} />
                  <span className="font-w500 fs-7">{`Password recovery`}</span>
                </div>

                <div className="d-flex ">
                  <div
                    className="step-circle"
                    style={{
                      // backgroundColor:
                      //   signUpSteps === 1
                      //     ? "#00000070"
                      //     : signUpSteps > 1
                      //       ? "#098000c2"
                      //       : "",
                      color: "orange",
                      borderColor: signUpSteps === 1 ? `orange` : '',
                      boxShadow: signUpSteps === 1 ? `0px 6px 12px 0px rgba(255, 154, 32, 0.24)` : ``,
                    }}
                  >
                    {signUpSteps === 1 ? 1 : signUpSteps > 1 ? <i className="fa fa-check"></i> : '1'}
                  </div>
                  <div
                    className="d-flex flex-column justify-content-center stepper-content"
                    style={{
                      color:
                        signUpSteps === 1 ? "black" : "",
                    }}
                  >
                    <span
                      className="stepper-title"
                    >
                      Forgot Password
                    </span>
                    <span className="stepper-sub-title">
                      Enter your login in Chilll
                    </span>
                  </div>
                </div>

                <div
                  className="step-line"
                  style={{
                    // backgroundColor: signUpSteps > 1 ? "#098000c2" : "",
                  }}></div>

                <div className="d-flex ">
                  <div
                    className="step-circle"
                    style={{
                      // backgroundColor:
                      //   signUpSteps === 2
                      //     ? "#00000070"
                      //     : signUpSteps > 2
                      //       ? "#098000c2"
                      //       : "",
                      // color: signUpSteps > 1 ? "white" : "black",
                      color: "orange",
                      borderColor: signUpSteps === 2 ? `orange` : '',
                      boxShadow: signUpSteps === 2 ? `0px 6px 12px 0px rgba(255, 154, 32, 0.24)` : ``,
                    }}>
                    {/* 2 */}
                    {signUpSteps === 2 ? 2 : signUpSteps > 2 ? <i className="fa fa-check"></i> : '2'}
                  </div>
                  <div
                    className="d-flex flex-column justify-content-center stepper-content"
                    style={{
                      color:
                        signUpSteps === 2 ? "black" : "",
                    }}
                  >
                    <span
                      className="stepper-title"
                    // style={{
                    //   color:
                    //     signUpSteps === 2 || signUpSteps > 2 ? "black" : "",
                    // }}
                    >
                      {"Reset Code"}
                    </span>
                    <span className="stepper-sub-title">
                      {"Enter the received code"}
                    </span>
                  </div>
                </div>

                <div
                  className="step-line"
                  style={{
                    // backgroundColor: signUpSteps > 2 ? "#098000c2" : "",
                  }}></div>

                <div className="d-flex ">
                  <div
                    className="step-circle"
                    style={{
                      // backgroundColor:
                      //   signUpSteps === 3
                      //     ? "#00000070"
                      //     : signUpSteps > 3
                      //       ? "#098000c2"
                      //       : "",
                      // color: signUpSteps > 2 ? "white" : "black",
                      color: "orange",
                      borderColor: signUpSteps === 3 ? `orange` : '',
                      boxShadow: signUpSteps === 3 ? `0px 6px 12px 0px rgba(255, 154, 32, 0.24)` : ``,
                    }}
                  >
                    {/* 3 */}

                    {signUpSteps === 3 ? 3 : signUpSteps > 3 ? <i className="fa fa-check"></i> : '3'}
                  </div>
                  <div
                    className=" d-flex flex-column justify-content-center stepper-content"
                    style={{
                      color:
                        signUpSteps === 3 ? "black" : "",
                    }}
                  >
                    <span
                      className="stepper-title"
                    // style={{
                    //   color:
                    //     signUpSteps === 3 || signUpSteps > 3 ? "black" : "",
                    // }}
                    >
                      Change password
                    </span>
                    <span className="stepper-sub-title">Set a new password</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div
            className="row align-content-center d-flex justify-content-between p-3 signUp-terms-policy-box w-100"
            style={{
              background: 'rgba(79, 93, 116, 1)',
            }}
          >
            <div className="col-6 d-flex justify-content-center">
              {" "}
              <a
                href="https://chilll.com/chilll-terms-conditions/"
                target="_blank"
                rel="noreferrer">
                <div
                  className="signUp-terms-policy text-hovered"
                  style={{ color: '#d3d3f18a' }}
                >
                  <span>{`Terms of Service`}</span>
                </div>
              </a>
            </div>

            <div className="col-6  d-flex justify-content-center">
              <a
                href="https://chilll.com/privacy-policy/"
                target="_blank"
                rel="noreferrer">
                <div
                  className="signUp-terms-policy text-hovered"
                  style={{ color: '#d3d3f18a' }}
                >
                  <span>{`Privacy Policy`}</span>
                </div>
              </a>
            </div>
            {/* <div className="col-4  d-flex justify-content-start">
              <a href="https://chilll.com" target="_blank" rel="noreferrer">
                <div className="signUp-terms-policy">
                  <span>Contact</span>
                  <span>Us</span>
                </div>
              </a>
            </div> */}
          </div>
        </div>

        <div
          className="col-xl-9 col-lg-9 col-md-8"
          style={{ background: `rgba(251, 252, 255, 1)` }}
        >
          <div className="row flex-column h-100  w-100">
            {/* <div className="align-items-center d-flex justify-content-center position-relative m-3">
              <div className="signup-steps-counter-for-mobile">
                <span>{`step ${signUpSteps} of 5`}</span>
              </div>

              {signUpSteps > 1 && signUpSteps < 5 &&
                <div onClick={handleBackSignup} className="align-items-center back-button-signup d-flex justify-content-center position-absolute">
                  <i className="bi bi-arrow-left back-button-signup-icon"></i>
                  Back
                </div>
              }
            </div> */}

            <div className="align-items-center d-flex justify-content-center sign-up-right-parent">
              <div className=" row signUp-right-content">
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ fontWeight: 700 }}>
                  <div className="pointer text-hovered" onClick={handleBackSignup}>
                    <i className="bi bi-arrow-left back-button-signup-icon pointer "></i>
                    <span>Back</span>
                  </div>
                </div>
                {signUpSteps === 1 && (
                  <div className="row">

                    <form onSubmit={handleSubmit}>
                      <div className="row align-items-center justify-content-center p-3 signUp-title">
                        <span>Forgot Password</span>
                      </div>
                      <div className="row align-items-center d-flex justify-content-center mb-3 ">
                        <span className="login-subtitle text-black">
                          {`Please enter your email address or phone number to search for your account`}
                        </span>
                      </div>

                      <div className="row align-items-center d-flex justify-content-between mb-2 mt-5">
                        <EmailPhoneCombine
                          isEnteringNumber={isPhone}
                          setIsEnteringNumber={setIsPhone}
                          handleInputValue={handleEmailPhone}
                          handleChangeCode={handleDropdownValue}
                          errorOccured={isEmailPhoneVal}
                          inputValue={emailPhoneValue}
                          handleOnBlur={handleBlur}
                          defaultCodeValue={codeValue}
                          errorMessage={loginErrorMsg}
                          isRequired={true}
                        />
                      </div>

                      <div className="col-sm-12">
                        <PrimaryButton
                          buttonName={`SEND ME RESET CODE`}
                          style={{
                            width: "100%",
                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                            border: '2px solid rgba(255, 154, 32, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          }}
                          loadingMessage={"Sending code..."}
                          type={"submit"}
                          needIcon={true}
                          isLoading={loaderActive}
                          iconClassName="bi bi-arrow-right"
                        />
                      </div>
                    </form>


                  </div>
                )}

                {signUpSteps === 2 && (
                  <div className="row">

                    <form onSubmit={handleSubmitCode}>
                      <div className="row align-items-center justify-content-center p-3 signUp-title">
                        <span>Enter the password reset code</span>
                      </div>
                      <div className="row align-items-center d-flex justify-content-center mb-3 ">
                        <span className="login-subtitle">
                          {`  We sent the reset code to `} <span className="font-w600">{`${emailPhoneValue}.`}</span> {` If you don't receive it soon, try re-sending your request.`}
                        </span>
                      </div>
                      <div className=" d-flex justify-content-center">
                        <span
                          className="font-w700 text-hovered cursor-pointer"
                          style={{
                            color: "rgba(131, 154, 192, 1)",
                          }} onClick={handleSubmit}>
                          Re-send request
                        </span>
                      </div>
                      <div className="row align-items-center d-flex justify-content-between mb-2 mt-5">
                        <InputField
                          labelName={"Password reset code"}
                          value={recievedCodeValue}
                          onChange={handleValidateCode}
                          errorOccured={isCodeError}
                          isLoading={loaderActive}
                          errorMeesage={"Enter valid password reset code"}
                          onBlur={handleCodeBlurCheck}
                        />
                      </div>

                      <div className="col-sm-12">
                        <PrimaryButton
                          type={"submit"}
                          buttonName={`CONFIRM RESET CODE`}
                          style={{
                            width: "100%",
                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                            border: '2px solid rgba(255, 154, 32, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          }}
                          loadingMessage={"Confirming code..."}
                          needIcon={true}
                          isLoading={loaderActive}
                          iconClassName="bi bi-arrow-right"
                        />
                      </div>
                    </form>

                  </div>
                )}

                {signUpSteps === 3 && (
                  <div className="row">

                    <form onSubmit={handleSubmitPassword}>
                      <div className="row align-items-center justify-content-center p-3 signUp-title">
                        <span>Change your password</span>
                      </div>
                      <div className="row align-items-center d-flex justify-content-center mb-3 ">
                        <span className="login-subtitle">
                          {` Set a new password for your account. `}
                        </span>
                      </div>

                      <div className="row align-items-center d-flex justify-content-between mb-2 mt-5">
                        <PasswordField
                          onChange={handleNewPassword}
                          inputValue={newPassword}
                          errorOccured={isNewPassword}
                          errorMessage={"invalid password"}
                          labelName={"New password"}
                          handleOnBlur={handleNewPasswordBlur}
                        />
                        <PasswordField
                          onChange={handleConfirmPassword}
                          inputValue={confirmPassword}
                          errorOccured={isConfirmPassword}
                          errorMessage={"Password doesnot match"}
                          labelName={"Confirm new password"}
                          handleOnBlur={handleConfirmPasswordBlur}
                        />
                      </div>

                      {isNewPassword && <PasswordChecker password={newPassword} />}

                      <div className="col-sm-12">
                        <PrimaryButton
                          type={"submit"}
                          buttonName={`CHANGE PASSWORD`}
                          style={{
                            width: "100%",
                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                            border: '2px solid rgba(255, 154, 32, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          }}
                          loadingMessage={"Changing password..."}
                          needIcon={false}
                          isLoading={loaderActive}
                          iconClassName="bi bi-arrow-right"
                        />
                      </div>
                    </form>

                  </div>
                )}
                {/* <div className="row mt-5">
                  <p className="text-center">
                    <span className="text-black font-w500">{`Do not have an account yet? `}</span>
                    <span
                      className=" font-w700 cursor-pointer text-hovered"
                      style={{ color: 'rgba(131, 154, 192, 1)' }}
                      onClick={() => {
                        navigate("/signup");
                      }}>
                      Sign up
                    </span>
                  </p>
                </div> */}
                <div className="row mt-2">
                  <p className="text-center">
                    <span className="text-black font-w500">{`Need further assistance? `}</span>
                    <a
                      href="https://chilll.com/contact/"
                      target="_blank"
                      rel="noreferrer">

                      <span className=" font-w700 cursor-pointer text-hovered" style={{ color: 'rgba(131, 154, 192, 1)' }}>{`Contact us`}</span>

                    </a>
                  </p>
                </div>

                <div className="row">
                  <span className="terms-condition-link text-center"
                    onClick={() => {
                      setFeedbackModal(true);
                    }}
                  >
                    {`Give us feedback`}
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {feedbackModal && (
        <FeedbackModal
          addUserTrigger={feedbackModal}
          handleCloseAddUser={handleFeedbackModal}
        />
      )}


      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
    </>
  );
}
